module.exports = __webpack_public_path__ + "img/volkswagen.e8941957.png";